import React from 'react';

import { Icon } from '../../../../components';
import type { StatsDelta } from '../../../../mock-data/types';
import { Pill, DELTA_COLORS, type DeltaVariant } from './Delta.styles';

export type DeltaProps = {
  delta: StatsDelta;
  /** Font size (px); the source uses 10 inside dense tiles, 13–14 in card leads. */
  size?: number;
};

/**
 * Change pill — "↑ +4.50%" / "↓ -0.40%". The label (sign + value) is pre-formatted
 * by the selector. The trend ARROW follows `dir` (a flat / first-render `+0.00%`
 * reads as a neutral green "up", matching the source); the COLOUR follows the optional
 * sentiment `tone` when set (inverted metrics like Live RTP, where a rise is red while
 * the arrow still points up), otherwise it tracks `dir`.
 */
export const Delta = ({ delta, size = 14 }: DeltaProps): React.ReactElement => {
  const arrow: DeltaVariant = delta.dir === 'down' ? 'down' : 'up';
  const color: DeltaVariant = delta.tone ? (delta.tone === 'negative' ? 'down' : 'up') : arrow;
  return (
    <Pill $variant={color} style={{ fontSize: size }}>
      <Icon name={arrow === 'down' ? 'trending-down' : 'trending-up'} size={size === 10 ? 10 : 12} color={DELTA_COLORS[color].fg} />
      {delta.label}
    </Pill>
  );
};

export default Delta;
